import React, { useEffect, useRef, useState } from "react";
import "../../Users/style.scss";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import companylogo from "../../../assets/images/companylogo.png";
import "sweetalert2/dist/sweetalert2.min.css";
import {
  fetchBookingist,
  getUserList,
  userStatusUpdate,
} from "../../../utils/api.js";
import { getDateFromDateObj, isEmpty, isNumber } from "../../../utils/common";
import LocalLoader from "../../../Components/Loader/LocalLoader.js";
import { FilterWrapper } from "../../../assets/styles/FilterStyle";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import Flight from "../../../assets/images/flight.svg";
import Hotel from "../../../assets/images/hotel.svg";
import Bus from "../../../assets/images/bus.svg";
import "../BookingList/BookingList.scss";
import BookingDetail from "./BookingDetail.jsx";
import DateRangePicker from "../../../Components/DateRangePicker/DateRangePicker.jsx";

require("react-datepicker/dist/react-datepicker.css");

const BookingList = () => {
  const [apiData, setApiData] = useState([]);
  const [bookingId, setBookingId] = useState("");
  const [traveller, setTraveller] = useState("");
  const [pnr, setPnr] = useState("");
  const [status, setStatus] = useState("");
  const [totalPages, setTotalPages] = useState(null);
  const [totalElements, setTotalElements] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pdfData, setPdfData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState("");

  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loginUserType, setLoginUserTye] = useState("");
  const [showfilter, setShowFilter] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [updatedUserStatus, setUpdatedUserStatus] = useState();

  const link = useRef();

    const clearRef = useRef(null);
  const clearDate = (callback) => {
    if (clearRef.current) return;
    clearRef.current = callback;
  };

  const constChangeDate = (startDate, endDate) => {
    if (endDate) {
      setEndDate(endDate);
      setStartDate(startDate);
    }
  };

  const onClearDate = () => {
    setEndDate("");
    setStartDate("");
  };

  // Date Format
  var currentDate = new Date();
  var formattedDate = [
    currentDate.getDate(),
    currentDate.getMonth() + 1,
    currentDate.getFullYear(),
  ]
    .map((n) => (n < 10 ? `0${n}` : `${n}`))
    .join("-");

  const navigate = useNavigate();

  let _fromDate = "";
  let _toDate = "";

  if (startDate !== "" && endDate !== "") {
    _fromDate = getDateFromDateObj(startDate, "YYYY-MM-DD");
    _toDate = getDateFromDateObj(endDate, "YYYY-MM-DD");
  } else {
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    _fromDate = getDateFromDateObj(thirtyDaysAgo, "YYYY-MM-DD");
    _toDate = getDateFromDateObj(today, "YYYY-MM-DD");
  }

  //API to fetch userlist

  const transformBookingsData = (bookings) => {
    if (!bookings) return [];

    return Object.entries(bookings).map(([date, bookingsArray]) => {
      return {
        date,
        entries: bookingsArray.map((booking) => {
          const segment = booking.segments[0];
          return {
            time: new Date(booking.createdAt).toLocaleString(),
            name: booking?.primaryTraveller || "N/A",
            bookingId: segment.bookingId,
            airline: `${segment?.airlines[0]?.code} - ${segment?.airlines[0]?.flightNumber}`,
            status: booking?.bookingStatus,
            pnr: segment?.pnr,
            tripeType: booking?.tripType,
            flights: `${segment.origin} - ${segment.destination}`,
            count: booking?.travellers - 1,
          };
        }),
      };
    });
  };

  const handleApiData = async (e, key) => {
    const param = {
      bookingId: bookingId,
      pnr: pnr,
      bookingstatus: status,
      traveller: traveller,
      start: _fromDate,
      end: _toDate,
    };

    const pagination = {
      currentPage: currPage,
      pageSize: pageSize,
    };
    if (key === "CSV" || key === "PDF") {
      if (key === "CSV") {
        setDownloadLoader("CSV");
      } else {
        setDownloadLoader("PDF");
      }
      pagination.pageSize = totalElements;
      pagination.currentPage = 0;
    }
    if (key === "search") {
      pagination.currentPage = 0;
      setCurrPage(0);
    } else {
      setLoading(true);
    }
    if (key === "refresh") {
      dataRefresh();
      param.username = "";
      param.fromDate = "";
      param.toDate = "";
      pagination.currentPage = 0;
      setCurrPage(0);
    } else {
      setLoading(true);
    }

    fetchBookingist(param).then((resp) => {
      setLoading(false);
      setDownloadLoader("");
      if (resp?.data.status) {
        const transformedData = transformBookingsData(
          resp?.data?.data?.bookings
        );
        if (key === "CSV") {
          let csvData = []
          transformedData?.map((block,)=>{
            csvData = block?.entries
          })
   
          setPdfData(csvData);

          setTimeout(() => {
            const csvlink = link.current;
            csvlink.link.click();
          }, 100);
        } else if (key === "PDF") {
          userlistPdfData(transformedData);
        } else {
          
          setApiData(transformedData);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
        }
      }
    });
  };
  useEffect(() => {
    handleApiData();
  }, [status]);

  //API to Export PDF file

  const userlistPdfData = (data = []) => {
    let _width = 350; // Width of the custom size
    const height = 297;
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm", // units: mm, cm, in, px
      format: [_width, height],
      compress: true,
      putOnlyUsedFonts: true,
      precision: 16, // n
    });
    //Add image in PDF header
    const imgWidth = 25;
    const imgHeight = 9;
    const leftXPos = 14;
    const yPos = 2;
    doc.addImage(companylogo, "PNG", leftXPos, yPos, imgWidth, imgHeight);

    //Add fileName in the center
    const text = "Booking List";
    // Calculate the width of the text
    const textWidth =
      (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    // Get the width of the PDF
    const pdfWidth = doc.internal.pageSize.width;
    const yPos1 = 10;
    // Calculate the X position for center alignment
    const centerXPos = (pdfWidth - textWidth) / 2;
    doc.text(text, centerXPos, yPos1);
    const generalFontSize = 12;
    doc.setFontSize(generalFontSize);
    // doc.setMargins(0,0,0,0);
    // Calculate the width of the date text
    const dateWidth =
      (doc.getStringUnitWidth(formattedDate) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;

    // Calculate the X position for right alignment
    const rightXPos = pdfWidth - dateWidth - 15; // 10 is for some margin from the right edge
    doc.text(formattedDate, rightXPos, yPos1);

    // Create a table from API data
 
    const tableData = [];
    data?.map((block,index)=>{

      block?.entries?.forEach((item, index) => {
            let date = item?.time?.split(",")
            const rowData = [
              index + 1,
              item?.time,
              item.name,
              item.pnr,
              item.bookingId,
              item?.airline +
                " | " +
                item?.flights +
                " | " +
                getDateFromDateObj(date, "DD MMM"),
              item.status,
            ]; // Customize as needed
            tableData.push(rowData);
          });
      
    })
   

    doc.autoTable({
      head: [
        [
          "S.No",
          "Created At",
          "Name",
          "Pnr",
          "Booking ID",
          "Flight",
          "Status",
        ],
      ], // Customize table header
      body: tableData,
    });

    doc.save("BookingList.pdf");
  };

  const handleDetailData = (e, key = "") => {
    const value = e.target.value;
    if (key === "number") {
      if (!isNumber(value) && !isEmpty(value)) return;
      setBookingId(e.target.value);
    } else {
      setTraveller(e.target.value);
      setPnr(e.target.value);
    }
  };

  const dataRefresh = () => {
    setStartDate("");
    setEndDate("");
    setBookingId("");
    setTraveller("");
    setPnr("")
    setStatus("");
    setCurrPage(0);
      if (clearRef.current) {
      clearRef.current();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleApiData();
    }
  };

  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (loginUserType === "" && !isEmpty(user?.userType)) {
      setLoginUserTye(user?.userType);
    }
  }, [user]);

  return (
    <>
      <div className="userlisthead_container">
        <div style={{ padding: "30px" }}>
          <div className="transaction_main_container">
            <div className="userlist_head">
              <div className="userlist_heading">
                <div className="userlist_left">
                  <label>Booking List</label>
                </div>
                <div className="userlist_right gap-10">
                  <button
                    className="bookinglist_btn"
                    onClick={() => navigate("/addUser")}
                  >
                    <img src={Flight} alt="Flight" />
                    <span>Flight</span>
                  </button>

                  <button
                    className="bookinglist_btn"
                    onClick={() => navigate("/addUser")}
                  >
                    <img src={Hotel} alt="Hotel" />
                    <span>Hotel</span>
                  </button>

                  <button
                    className="bookinglist_btn"
                    onClick={() => navigate("/addUser")}
                  >
                    <img src={Bus} alt="Bus" />
                    <span>Bus</span>
                  </button>
                </div>

                <div className="userlist_right">
                  {downloadLoader !== "PDF" ? (
                    <button
                      className="pdf"
                      onClick={(e) => handleApiData(e, "PDF")}
                    >
                      PDF
                    </button>
                  ) : (
                    <button className="pdf">
                      <div className="btn-loader">
                        <i className="fa-solid fa-spinner"></i>
                      </div>
                    </button>
                  )}
                  {downloadLoader !== "CSV" ? (
                    <button
                      className="xls"
                      onClick={(e) => handleApiData(e, "CSV")}
                    >
                      CSV
                    </button>
                  ) : (
                    <button className="xls">
                      <div className="btn-loader">
                        <i className="fa-solid fa-spinner"></i>
                      </div>
                    </button>
                  )}
                  <CSVLink
                    ref={link}
                    data={pdfData}
                    filename="Userlist.csv"
                  ></CSVLink>
                </div>
                <div className="userlist_filter">
                  <button
                    className="filter fs-16"
                    onClick={(e) =>
                      showfilter === "active"
                        ? setShowFilter("")
                        : setShowFilter("active")
                    }
                  >
                    <i className="fa-solid fa-filter"></i>
                  </button>
                </div>
              </div>
            </div>

            <FilterWrapper
              style={{ height: "auto" }}
              className={`display_data ${showfilter}`}
            >
              <div className="filterBox">
                <div>
                <div className="flex align-items gap-20">
                  <div>
                    <input
                      type="text"
                      name="bookingId"
                      placeholder="Enter booking id"
                      value={bookingId}
                      onChange={(e) => handleDetailData(e, "number")}
                      maxLength={10}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="pnr"
                      placeholder="Enter pnr number"
                      value={pnr}
                      onChange={(e) => handleDetailData(e, "number")}
                      maxLength={10}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="traveller"
                      placeholder="Enter traveller name"
                      value={traveller}
                      onChange={(e) => handleDetailData(e, "text")}
                      maxLength={10}
                      onKeyDown={handleKeyDown}
                    />
                  </div>

                  {/* <div className="input-field">
                    <div className="flex">
                      <DatePicker
                        showIcon
                        className="date-picker2 date_type"
                        placeholderText="From Date"
                        selected={startDate}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        yearDropdownItemNumber={100}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={(date) => setStartDate(date)}
                        maxDate={new Date()}
                      />
                    </div>
                  </div>
                  <div className="input-field">
                    <div className="flex">
                      <DatePicker
                        showIcon
                        className="date-picker2 date_type"
                        placeholderText="To Date"
                        selected={endDate}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        yearDropdownItemNumber={100}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={(date) => setEndDate(date)}
                       maxDate={new Date(new Date().setDate(new Date().getDate() + 31))}
                      />
                    </div>
                  </div> */}
                   <DateRangePicker
                    applyDate={constChangeDate}
                    defaultDate={null}
                    onClear={onClearDate}
                    clearDate={clearDate}
                    addMonth={2}
                  />
                  <div className="input-field">
                    <select
                      className="input_select_field"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      {/* <option value={""}>User Type</option> */}

                      <option value="">Status</option>
                      {loginUserType === "ROLE_ADMIN" && (
                        <>
                          <option value="CONFIRMED">Confirmed</option>
                          <option value="CANCELLED">Cancelled</option>
                          <option value="COMPLETED">Completed</option>
                        </>
                      )}
                    </select>
                  </div>
                  <div className="button">
                    <button
                      className="userlist_btn"
                      onClick={(e) => handleApiData(e, "search")}
                    >
                      Search
                    </button>
                  </div>

                  <div className="button">
                    <button
                      className="refresh-btn"
                      onClick={(e) => handleApiData(e, "refresh")}
                    >
                      <i className="fa fa-refresh"></i>
                    </button>
                  </div>
                </div>
                </div>
                
              </div>
            </FilterWrapper>
          </div>

          <div className="table-loader">
            {loading && <LocalLoader className="tableLoader" />}
            <div className="booking-table">
              {apiData?.map((block, blockIdx) => {
                return (
                  <div className="booking-date-block" key={blockIdx}>
                    <div className="booking-row-wrapper">
                      <div className="booking-date">
                        <strong>
                          <span className="date-day">
                            {
                              getDateFromDateObj(block.date, "DD MMM").split(
                                " "
                              )[0]
                            }
                          </span>
                          <br />
                          <span className="date-month">
                            {
                              getDateFromDateObj(block.date, "DD MMM").split(
                                " "
                              )[1]
                            }
                          </span>
                        </strong>
                      </div>
                      <div className="booking-entries">
                        <div className="booking-header fw-bold">
                          <div>SN</div>
                          <div>Created On</div>
                          <div>Name</div>
                          <div>Pnr</div>
                          <div>Booking ID</div>
                          <div>Flight</div>
                          <div>Status</div>
                          <div>Summary</div>
                        </div>
                        {block?.entries?.map((entry, entryIdx) => {
                          let date = entry?.time?.split(",");
                          return (
                            <div className="booking-row" key={entryIdx}>
                              <div>{entryIdx + 1}</div>
                              <div>{date[1]}</div>
                              <div>
                                {entry?.name}
                                {entry?.count > 0 && `, +${entry.count}`}
                              </div>

                              <div>{entry?.pnr}</div>
                              <div className="bookingid">
                                {entry?.bookingId}
                              </div>

                              <div className="flight-details">
                                {/* {entry?.flights?.map((f, i) => {
     
                                return(
                                  <div key={i}>{f?.name}</div>
                                )
                              })} */}
                                <div>
                                  {entry?.airline +
                                    " | " +
                                    entry?.flights +
                                    " | " +
                                    getDateFromDateObj(date, "DD MMM")}
                                </div>
                              </div>
                              <div
                                className={`status ${entry.status.toLowerCase()}`}
                              >
                                {entry.status}
                              </div>
                              <div>
                                <button
                                  className="view-btn"
                                  //onClick={() => setSelectedBooking(entry)}
                                >
                                  <i className="fa-solid fa-eye"></i> View
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {/* {totalPages > 1 && (
              <Pagination
                items={apiData}
                itemsPerPage={pageSize}
                setitemsPerPage={setPageSize}
                currentPage={currPage}
                setcurrentPage={setCurrPage}
                totalPages={totalPages}
                forcePage={currPage}
              />
            )} */}
        </div>
        <BookingDetail
          isOpen={!!selectedBooking}
          data={selectedBooking}
          onClose={() => setSelectedBooking(null)}
        />
      </div>
    </>
  );
};
export default BookingList;
